<lib-renderer-container
  [params]="params"
  [tooltip]="getValueFromRepository()"
>
  &nbsp;
  <span class="display-value">{{ getValuesFromRepository() | weekday }}</span>
  <mat-icon class="expand-icon" svgIcon="{{EsvgFiles.arrow_down}}" *ngIf="cellEditable()"
            (click)="startEdit($event)"></mat-icon>
</lib-renderer-container>
